import { Signal } from "@lit-labs/signals";
import type { IPreviewState } from "./types";

export class PreviewState implements IPreviewState {
  readonly isPreviewMode: Signal.State<boolean>;

  constructor(isPreview: boolean = false) {
    this.isPreviewMode = new Signal.State(isPreview);
  }
}
